<template>
    <article class='popupBG' v-if='showPopup'>
        <div class='popup' :class="{wide: wide, [addedClass]: addedClass}">
            <div :class="{noHeader: !header, title: header}">
                <h2 v-if="header">{{ header }}</h2>
                <div v-if="!noCloseX" class='close' @click="$emit('close-popup')"></div>
            </div>
            <div class='content scroll'>
                <slot name="content"></slot>
            </div>
            <div v-if="attentionContent" class='content'>
                <slot name="attention-content"></slot>
            </div>
            <div class="buttons">
                <slot name="buttons"></slot>
            </div>
        </div>
        <div class='popupCloseWrap' @click="$emit('close-popup')"></div>
    </article>
</template>

<script>
/* 
    "showPopup": boolean prop used to control when this popup shows
    "wide": boolean prop used to style the popup to be the wide version
    "header": string prop to set the popup title, if none is passed in, the popup uses the "noHeader" styles
    "noCloseX": boolean prop that can be set when the closing (X) shouldn't be on popup
    "content" slot: used to pass in whatever content should be displayed inside popup, buttons are separate slot
    "attention-content" slot: used for unscrollable content that should grab attention (ex. I Agree checkbox)
        placed after any scrollable content but before action buttons
        "attentionContent" must be set to true for this content to show
    "buttons" slot: used to pass in 1/multiple button elements, empty if non passed in 
*/
export default {
    name: 'Popup',
    props: ['showPopup', 'wide', 'addedClass', 'header', 'noCloseX', 'attentionContent']
}
</script>